import React from "react"
import {Modal} from "react-bootstrap"
import {injectIntl, defineMessages} from "react-intl"
import {Intl} from "../../../state/helpers/IntlProps"
import {useDispatch, useSelector} from "react-redux"
import {getDeletedMatrixItems} from "../../../state/product/ProductSelectors"
import {Row} from "../../../common/listing/ListingTypes"
import {MatrixItemDto} from "../../../state/product/matrix/matrix-item/MatrixItem"
import Icon from "../../../common/icon/icon.component"
import {restoreMatrixItem} from "../../../state/product/ProductActions"
import StandardList from "../../../common/listing/list.component"

const messages = defineMessages({
    title: {
        id: "product.variant.component.restore_matrix_item_modal.title",
        defaultMessage: "Restore Variants",
    },
    header_title: {
        id: "product.variant.component.restore_matrix_item_modal.header_title",
        defaultMessage: "Variant name",
    }
})

type Props = {
    intl: Intl
    onCloseCallback: () => void
}

function RestoreMatrixItemModal(props: Props) {
    const items = useSelector(getDeletedMatrixItems)
    const dispatch = useDispatch()

    const rows: Row<MatrixItemDto>[] = items.map(item => {
        return {
            rowId: item.id,
            data: [
                item.attributes.product.attributes.title,
                <a href={"#"}
                    key={0}
                    onClick={e => {
                        e.preventDefault()
                        dispatch(restoreMatrixItem({
                            id: item.id
                        }))
                    }}>
                    <Icon value={"undo"}/>
                </a>
            ],
            metadata: item
        }
    })

    const headers: string[] = [
        props.intl.formatMessage(messages["title"]),
        ""
    ]


    return (
        <Modal show={true} onHide={props.onCloseCallback}>
            <Modal.Header closeButton>
                <Modal.Title>
                    {props.intl.formatMessage(messages["header_title"])}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <StandardList
                    headers={headers}
                    rows={rows}
                />
            </Modal.Body>

        </Modal>
    )
}

export default injectIntl(RestoreMatrixItemModal)


// WEBPACK FOOTER //
// ./src/product/variant/modal/RestoreMatrixItemModal.tsx